<div
  class="card-ftd"
  [ngClass]="{
    'card-ftd--suggest-half': isHalf,
    'card-ftd--suggest-full': !isHalf,
    'card-ftd--prime': primeOffer()
  }"
>
  <div
    class="card-ftd__card-unique"
    [ngClass]="{
      'card-ftd__card-unique--suggest-half': isHalf,
      'card-ftd__card-unique--suggest-full': !isHalf,
      'card-ftd__card-unique--suggest-full-prime': !isHalf && primeOffer()
    }"
  >
    <section class="card-unique__information">
      <app-quantity-controls
        class="add-button"
        [class.add-information__add-button]="configModule?.additionalInf"
        [idPrefix]="idPrefix"
        [product]="product"
        [isCard]="true"
        [isMiniCard]="isMini"
        [isHome]="isHome"
        [queryID]="queryID"
        [positions]="positions + 1"
      ></app-quantity-controls>

      <div
        *ngIf="product?.variants?.length > 0 || product?.itemOpticsComplete"
        class="add-button add-information__add-button"
      >
        <a class="add-information__add-button-link add-button__link" [routerLink]="[urlGo]">
          <img
            src="/assets/svg/arrow-right-white.svg"
            alt="detail"
            class="add-button__arrow-right"
            id="icon-detail-marketplace"
          />
        </a>
      </div>

      <a class="content-product" [routerLink]="[urlGo]" (click)="algoliaEvent()">
        <div class="text-left info">
          <div class="price text-left">
            <div
              *ngIf="configModule?.additionalInf?.price && product.taxes > 0"
              class="additional-information"
            >
              <p class="price__text price__text-unit-price">
                {{ product.unitPrice | multiCountryCurrency }}
              </p>
              <p class="price__text price__text-taxes">
                Iva {{ product.taxes | multiCountryCurrency }}
              </p>
            </div>

            <p class="price-container" *ngIf="!shouldDisplayPrimePetal()">
              <app-offer-petal
                [offerText]="product?.offerText"
                [description]="product?.description"
                [detailDescription]="product?.detailDescription"
                [noPrimePetal]="true"
                [isHalf]="isHalf"
              ></app-offer-petal>

              <span class="price__wrapper">
                <span
                  class="price__text-price"
                  *ngIf="showPriceTag()"
                  [ngClass]="{ 'price__full-price': !product.offerPrice && !product.primePrice }"
                >
                  {{ showPriceText() | multiCountryCurrency }}
                </span>

                <span
                  class="price__text-offer-price"
                  *ngIf="showPrimePriceText()"
                  [class.offer-only]="!product.primePrice && !isSustitutes"
                  [class.prime-only]="product.primePrice && !isSustitutes && primeOffer()"
                  [class.card-ftd__price-offer--sustitutes]="isSustitutes"
                >
                  {{ product.fullPrice | multiCountryCurrency }}
                </span>
              </span>
            </p>

            <div *ngIf="shouldDisplayPrimePetal()">
              <app-prime-petal-long
                [customClasses]="'prime-petal-long--price'"
                [value]="product.primePrice"
                [primeOffer]="product.primeTextDiscount"
                [isUnique]="true"
                [group]="groupType"
                [priceText]="product.fullPrice"
                [isHalf]="isHalf"
              ></app-prime-petal-long>
            </div>

            <div 
              *ngIf="shouldDisplayNoPrimePetal()"
              [ngClass]="{'prime-tag': isHalf}"
            >
              <app-prime-petal-long 
                *ngIf="shouldDisplayNoPrimePetalTag()"
                [customClasses]="'prime-petal-long--price'" 
                [value]="product.primePrice"
                [group]="groupType"
                [isHalf]="isHalf"
                [primeTag]="true"
              ></app-prime-petal-long>
            </div>
          </div>

          <p 
            class="text-title"
            [ngClass]="{
              'text-title--suggest-half': suggestedHalf,
              'text-title--suggest-prime-half': suggestedPrimeHalf,
              'text-title--suggest-full': suggestedFull
            }"
          >
            {{ product.description | titlecase }} {{ product.detailDescription }}
          </p>
        </div>
      </a>
    </section>

    <section class="card-unique__image">
      <app-product-image
        class="product-image"
        [isAlgolia]="isAlgolia"
        [product]="product"
        [isCard]="true"
        [browser]="browser"
        [queryID]="queryID"
        [positions]="positions + 1"
        [class.add-information__product-image]="configModule?.additionalInf"
        [class.add-information__card-offer-product-image]="isOffer && configModule?.additionalInf"
        [group]="groupType"
        [isHalf]="isHalf"
        [isHome]="isHome"
        [isSuggest]="true"
      ></app-product-image>
    </section>
  </div>
</div>